<div class="chatbot">
  <df-messenger
    intent="WELCOME"
    chat-title="Marketplace Chatbot"
    agent-id="2874644d-3789-4a0a-bf00-48fe363fd005"
    chat-icon="https://www.gstatic.com/dialogflow-console/common/assets/integrations/icons/messenger-cx-chat-icon.svg"
    language-code="en"
    wait-open="true"
  ></df-messenger>
</div>
